import { FC, MouseEventHandler, ReactNode } from "react";

export const ValidButton: FC<{
    onClick: MouseEventHandler<HTMLButtonElement>;
    children: ReactNode;
  }> = ({ onClick, children }) => {

    return <>
    <button className="validButton" onClick={onClick}>{children}</button>
    </>
}